import React from 'react';
import InterfacesList from './components/InterfacesList';

const InterfacesView = () => (
  <InterfacesList />
);

export default InterfacesView;
